import DateTimePicker from "components/Editorial/ContentCommentManager/DateTimePicker";
import i18n from "lib/i18n";
import LastEditedBy from "components/Editorial/ContentCommentManager/LastEditedBy";
import PropTypes from "prop-types";
import React from "react";

import {
  Dialog,
  DialogAction,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Switch
} from "@theconversation/ui";

const CommentManagerDialog = ({
  changeCommentsCloseDate,
  commentsClosed,
  commentsClosingAt,
  handleSubmit,
  lastEditedDate,
  lastEditedUserName,
  modalIsOpen,
  onClose,
  toggleCommentsClosed,
}) => (
  <Dialog
    onClose={onClose}
    open={modalIsOpen}
  >
    <DialogTitle>
      {i18n.t("comment_manager.dialog.title")}
    </DialogTitle>

    <DialogContent>
      <LastEditedBy date={lastEditedDate} name={lastEditedUserName} />

      <FormGroup>
        <FormControlLabel
          control={<Switch
            colour="primary"
            checked={!commentsClosed}
            onChange={toggleCommentsClosed}
          />}
          label={i18n.t("comment_manager.labels.allow_comments")}
        />
      </FormGroup>

      <DateTimePicker
        disabled={commentsClosed}
        onChange={changeCommentsCloseDate}
        value={commentsClosingAt}
      />
    </DialogContent>

    <DialogActions>
      <DialogAction onClick={onClose}>
        {i18n.t("comment_manager.buttons.cancel")}
      </DialogAction>

      <DialogAction variant="primary" onClick={handleSubmit}>
        {i18n.t("comment_manager.buttons.confirm")}
      </DialogAction>
    </DialogActions>
  </Dialog>
);

CommentManagerDialog.defaultProps = {
  commentsClosingAt: "",
  lastEditedDate: "",
  lastEditedUserName: "",
};

CommentManagerDialog.propTypes = {
  changeCommentsCloseDate: PropTypes.func.isRequired,
  commentsClosed: PropTypes.bool.isRequired,
  commentsClosingAt: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  lastEditedDate: PropTypes.string,
  lastEditedUserName: PropTypes.string,
  modalIsOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  toggleCommentsClosed: PropTypes.func.isRequired,
};

export default CommentManagerDialog;
